import { useSelector } from "react-redux";
import { State } from "../../../reducer";
import { FC } from "react";
import { patchSoftDeleteCategoryByID } from "../../../api/category.api";

type ModalProps = {
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
};
export const DeleteCategory: FC<ModalProps> = ({ open, onClose, onSuccess = () => { } }) => {
  const category = useSelector((state: State) => state.category);
  if (!open) return null;

  const handlePlaceOrder = async () => {
    const responseStatus = await patchSoftDeleteCategoryByID(category.category_id);
    if (responseStatus.isAvailable === "unavailable") {
      console.log("DELETE OK CATEGORY");
      onClose();
      onSuccess();
    } else {
      console.error(responseStatus);
    }
  };

  return (
    <>
      <div className="h-screen w-full fixed left-0 top-0 bg-black bg-opacity-25 font-nunito">
        <div className="relative h-full w-full flex flex-col justify-center items-center ">
          <div className="border-0 w-11/12 rounded-lg shadow-lg relative flex flex-col bg-white  p-[16px] ">
            <div className="flex items-start justify-between">
              <div className="font-medium text-16 text-left font-nunito"
                style={{
                  wordBreak: "break-word",
                  display: "inline-block",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "80%",
                }}>
                Delete {category.category_name}?
              </div>
              <button className="flex justify-start" onClick={onClose}>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.3 0.709971C12.91 0.319971 12.28 0.319971 11.89 0.709971L6.99997 5.58997L2.10997 0.699971C1.71997 0.309971 1.08997 0.309971 0.699971 0.699971C0.309971 1.08997 0.309971 1.71997 0.699971 2.10997L5.58997 6.99997L0.699971 11.89C0.309971 12.28 0.309971 12.91 0.699971 13.3C1.08997 13.69 1.71997 13.69 2.10997 13.3L6.99997 8.40997L11.89 13.3C12.28 13.69 12.91 13.69 13.3 13.3C13.69 12.91 13.69 12.28 13.3 11.89L8.40997 6.99997L13.3 2.10997C13.68 1.72997 13.68 1.08997 13.3 0.709971Z"
                    fill="#292929"
                  />
                </svg>
              </button>
            </div>
            <div className="relative flex-auto">
              <p className="flex my-16 text-slate-700 text-lg leading-relaxed text-16 font-nunito font-normal">
                The menu of deleted category.
              </p>
            </div>
            <div className="flex flex-row">
              <button
                className="w-full h-48 text-slate-700 font-nunito text-16  items-center bg-netural-N40 rounded-lg mr-[2px]"
                onClick={onClose}
              >
                Close
              </button>
              <button
                className="w-full h-48 text-white items-center font-nunito text-16 bg-red-500 rounded-lg ml-[2px]"
                onClick={handlePlaceOrder}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
